import React, { useEffect, useState } from "react";
import { Layout, Spin } from "antd";
import '../CSS/style-guide.css'


const { Footer } = Layout;

const FooterJs = () => {
    const [meta, setMeta] = useState(null);
    const [loading, setLoading] = useState(true);
    const [err, setErr] = useState(null);

    useEffect(() => {
        let mounted = true;
        (async () => {
            try {
                const res = await fetch("/api/metadata-cache");
                if (!res.ok) throw new Error(`Status ${res.status}`);
                const data = await res.json();
                if (!mounted) return;

                // try to parse dates to human readable
                const parseDate = (d) => {
                    if (!d) return null;
                    const parsed = new Date(d);
                    if (!isNaN(parsed.getTime())) return parsed.toLocaleString();
                    return d; // return raw if not parseable
                };

                // format as "dd MMM YYYY" (e.g. "05 Jul 2025")
                const formatDateDDMMMYYYY = (d) => {
                    if (!d) return null;
                    const parsed = new Date(d);
                    if (!isNaN(parsed.getTime()))
                        return parsed.toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' });
                    return d;
                };
                
                setMeta({
                    metadataRefreshedOn: formatDateDDMMMYYYY(data.metadataRefreshedOn),
                    jobRunTimestamp: parseDate(data.jobRunTimestamp),
                    totalActiveContracts: data.totalActiveContracts ?? null,
                    totalContractsUpdated: data.totalContractsUpdated ?? null
                });
            } catch (e) {
                console.warn("Failed to load metadata-cache:", e);
                if (!mounted) return;
                setErr(true);
            } finally {
                if (mounted) setLoading(false);
            }
        })();
        return () => { mounted = false; };
    }, []);

    return (
        <Footer className="footer" style={{ fontSize: 12 }}>
            Supplier Contract Insights & Analytics ©{new Date().getFullYear()} Created by Ant UED
            {loading ? (
                <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 8 }}>
                    <Spin size="small" /> <span>Loading cache metadata…</span>
                </div>
            ) : err ? (
                <div>Cache metadata unavailable</div>
            ) : meta ? (
                <div style={{ display: "flex", gap: 16, flexWrap: "wrap", justifyContent: "center", alignItems: "center" }}>
                    <div>Last Updated: <strong>{meta.metadataRefreshedOn ?? "N/A"}</strong></div>
                    {/* <div>Cache created: <strong>{meta.jobRunTimestamp ?? "N/A"}</strong></div> */}
                    <div>Total active contracts: <strong>{meta.totalActiveContracts ?? "N/A"}</strong></div>
                    {/* <div>Total contracts updated: <strong>{meta.totalContractsUpdated ?? "N/A"}</strong></div> */}
                </div>
            ) : (
                <div>No cache metadata</div>
            )}
        </Footer>
    );
};

export default FooterJs;